import color from "../../constants/color";

const styles = {
  mainHeading: {
    fontSize: "20px",
    fontWeight: "600",
  },
  mainBox: {
    pt: "10px",
    m: "16px",
    width: "100%",
  },
  
  permissionText: {
    fontSize: "16px",
    fontWeight: "500",
    pt: "30px",
  },
  whiteSection: {
    m: "16px",
    backgroundColor: color.card,
    px: "20px",
    pb: "30px",
    borderRadius: "20px",
    display: "flex",
    justifyContent: "space-between",
    mt: 0,
  },
  employeeName: {
    width: "85%"
  },
  customHeading: {
    fontSize: "14px",
    fontWeight: "500",
    color: color.primary,
  
  },
  line: {
    borderBottom: "1px solid #28AA4A",
    mt: 2,
  
  },
  permissionLine: {
    border: "1.5px solid #28AA4A",
    width: "20px",
    mr: 1,
  },
  lineTextGrid: {
    display: "flex",
    alignItems: "center",
  },
  subheadingBox: {
    mt: 3,
    width: "fit-content",
  },
  permissionHeading: {
    fontSize: "14px",
    fontWeight: "500",
      
  },
  greyText: {
    color: color.lightText,
    fontSize: "12px",
    fontWeight: "400",
    mt: 1,
  },
  sectionGrid: {
    display: "flex", 
    alignItems: "end", 
    justifyContent: "space-between", 
    mt: 3,
  },
  gridSubBox: {
    display: "flex",
    mt: 4,
    alignItems: "center",
    // justifyContent: "space-between",
  },
  condition: {
    fontSize: "14px",
    fontWeight: "400",
    color: color.lightText,
    ml: 1
  
  },
  mainBoxes: {
    m: "10px",
    px: "10px",
    display: "flex",
    mb: 3,
  },
  restoreButtons: {
    borderRadius: 50, 
    textTransform: "none", 
    color: color.lightText,
    border: "1px solid #878787",
    fontSize: "12px",
    fontWeight: "500",
    backgroundColor: "#fff",
    boxShadow: "none",
  },
  jobButtons: {
    borderRadius: 50, 
    textTransform: "none", 
    backgroundColor: "#28AA4A", 
    fontSize: "14px",
    fontWeight: "500",
    px: 4,
  },
  cancelButtons: {
    borderRadius: 50, 
    textTransform: "none", 
    backgroundColor: "#878787",
    fontSize: "14px",
    fontWeight: "500",
    ml: 3,
    px: 4,
  
  },
  radioContainer:{
    display:"flex",
    flexDirection:"row",
    alignItems:"center",
    // mb:1,
  },
  radioContainers:{
    display:"flex",
    flexDirection:"row",
    alignItems:"center",
    ml: 3,
  },
  
  radioBtn: {
    m: 0,
    "& .css-wxwe5p-MuiButtonBase-root-MuiRadio-root":{
      padding:0
    }
  }
    
}
export default styles
    